var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecoStarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 478.71,
    height: 478.709,
    viewBox: "0 0 478.71 478.709",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    opacity: 0.1,
    d: "M264.676 0C268.995 0.000263856 272.496 3.5013 272.496 7.82031V155.633L352.688 75.4404C355.743 72.3866 360.695 72.3864 363.749 75.4404L398.396 110.088C401.45 113.142 401.45 118.094 398.396 121.148L313.33 206.215H470.89C475.209 206.215 478.71 209.716 478.71 214.035V264.674C478.71 268.993 475.209 272.494 470.89 272.494H318.992L394.3 347.804C397.354 350.858 397.354 355.81 394.3 358.864L359.652 393.512C356.598 396.566 351.646 396.566 348.592 393.512L272.496 317.416V470.889C272.496 475.208 268.995 478.709 264.676 478.709H214.036C209.717 478.709 206.216 475.208 206.216 470.889V313.328L126.023 393.521C124.557 394.988 122.567 395.811 120.493 395.812C118.419 395.812 116.43 394.988 114.963 393.521L80.3154 358.874C77.2613 355.82 77.2613 350.868 80.3154 347.813L155.635 272.494H7.82129C3.50212 272.494 0 268.993 0 264.674V214.035C0 209.716 3.50212 206.215 7.82129 206.215H161.295L76.2266 121.147C73.1725 118.093 73.1725 113.141 76.2266 110.087L110.874 75.4385C112.341 73.972 114.33 73.1485 116.404 73.1484C118.478 73.1486 120.468 73.972 121.935 75.4385L206.216 159.719V7.82031C206.216 3.50114 209.717 0 214.036 0H264.676Z",
    fill: "url(#paint0_linear_0_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4",
    x1: 39.7654,
    y1: 108.073,
    x2: 547.348,
    y2: 370.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5170FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoStarBlue);
export default __webpack_public_path__ + "static/media/deco-star-blue.a5a99ce4b1a02fd87438b22e1c486990.svg";
export { ForwardRef as ReactComponent };